<template>
  <div class="traceability-events-stepper">
    <div
      v-for="(event, index) in events"
      :key="event.status"
      class="traceability-events-stepper-item"
      :class="{
        'active': activeFilter(event.status),
        'last-active': index === currentEventIndex
      }"
    >
      <div class="traceability-events-stepper-item-icon">
        <svg-loader
          :src="`/static/images/icon-traceability-event-${event.status}.svg`"
        />
      </div>

      <div class="traceability-events-stepper-item-content">
        <div class="traceability-events-stepper-item-label">
          {{ traceabilityStatusLabels[event.status] }}
        </div>

        <div
          v-if="event.date"
          class="traceability-events-stepper-item-date"
        >
          {{ event.date | date }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { traceabilityStatusLabels } from '@/constants';

export default {
  name: 'TraceabilityEventsStepper',
  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    currentStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      traceabilityStatusLabels,
    }
  },
  computed: {
    currentEventIndex() {
      return this.events.findIndex(event => event.status === this.currentStatus)
    },
  },
  methods: {
    activeFilter(status){
      if(status == "CADASTRADO"){
        return true;
      } else if(status == "EM_TRANSITO"){
        return this.checkAtual();
      } else if(status == "EM_TRANSITO_ENTRE_NTO"){
        return this.checkEntregueNto();
      }

      return false;
    },
    checkAtual(){
      if(this.currentStatus == 'AGUARDANDO_RETIRADA' || this.currentStatus == 'AMOSTRA_OBTIDA' || this.currentStatus == 'CADASTRADO')
        return false;

      return true;
    },
    checkEntregueNto(){
      if(this.currentStatus == 'AGUARDANDO_RETIRADA' || this.currentStatus == 'AMOSTRA_OBTIDA' || this.currentStatus == 'CADASTRADO' || this.currentStatus == 'EM_TRANSITO')
        return false;

      return true;
    },
  }
}
</script>

<style lang="scss" scoped>
.traceability-events-stepper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    color: #7F1A54;
    padding-left: 1rem;
    padding-right: 1rem;
    position: relative;

    &-icon {
      border: 2px solid #CCCCCC;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .md-icon {
        width: 1.5rem;
        height: 1.5rem;
        min-width: auto;
        min-height: auto;
        color: #CCCCCC;
      }

      &::before {
        content: "";
        height: 3px;
        background-color: #CCCCCC;
        position: absolute;
        top: 18.5px;
        right: calc(50% + 20px);
        left: 0;
      }

      &::after {
        content: "";
        height: 3px;
        background-color: #CCCCCC;
        position: absolute;
        top: 18.5px;
        left: calc(50% + 20px);
        right: 0;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      text-align: center;
    }

    &-label {
      font-weight: 700;
      font-size: 0.875rem
    }

    &-date {
      font-weight: 400;
      font-size: 0.875rem;
    }
  }

  &-item:first-child &-item-icon::before {
    display: none;
  }

  &-item:last-child &-item-icon::after {
    display: none;
  }

  &-item.active &-item-icon {
    border-color: #EC2072;
  }

  &-item.active &-item-icon .md-icon {
    color: #EC2072;
  }

  &-item.active &-item-icon::before {
    background-color: #EC2072;
  }

  &-item.active &-item-icon::after {
    background-color: #EC2072;
  }

  &-item.last-active &-item-icon::after {
    background-color: #CCCCCC;
  }
}
</style>
